import React from 'react'
import {Accordion, Panel, Button, Glyphicon} from 'react-bootstrap';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import ProductItem from "./product-item";

const CategoryAccordion = ({categories, itemName, statusAttribute, ...props}) => {

  const ProductListSortable = SortableContainer(({items, itemType, categoryName, statusAttribute}) => {
    return (
      <div>
        {
          items.map((item, index) => {
            return <ProductSortable key={index}
                                    index={index}
                                    item={item}
                                    itemType={itemType}
                                    categoryName={categoryName}
                                    statusAttribute={statusAttribute}/>
          })
        }
      </div>
    )
  });

  const ProductSortable = SortableElement(({item, itemType, categoryName, statusAttribute}) => {
    return (
      <ProductItem key={item.id}
                   item={item}
                   itemType={itemType}
                   image={item.links.image}
                   categoryName={categoryName}
                   status={item[statusAttribute]}
                   deleteDisabled={item.has_products}
                   {...props}/>
    )
  });

  const handleSort = (categoryId, brandId, {oldIndex, newIndex}) => {
    props.onSortEnd(categoryId, brandId, oldIndex, newIndex);
  };

  return (
    <Accordion>
      {
        categories.map((category, index) => {
          if(itemName === 'brands') {
            const key = `${category.id}`;
            const name = category.attributes.name;

            return (
              <Panel key={key}
                     eventKey={key}
                     header={<div><Button bsStyle="link">{name}</Button></div>}>
                <ProductListSortable items={category.attributes[itemName]}
                                     itemType="Brand"
                                     statusAttribute={statusAttribute}
                                     lockAxis="y"
                                     pressDelay={50}
                                     helperClass="product-reordering"
                                     onSortEnd={(...params) => handleSort(category.id, undefined, ...params)}/>
              </Panel>
            )
          } else if(itemName === 'products') {
            return category.attributes.brands.map((brand, index) => {
              const key = `${category.id}-${brand.id}`;
              const name = `${brand.name} - ${category.attributes.name}`;

              return (
                <Panel key={key}
                       eventKey={key}
                       header={<div><Button bsStyle="link">{name}</Button></div>}>
                  <ProductListSortable items={brand[itemName]}
                                       itemType="Product"
                                       categoryName={category.attributes.name}
                                       statusAttribute={statusAttribute}
                                       lockAxis="y"
                                       pressDelay={150}
                                       helperClass="product-reordering"
                                       onSortEnd={(...params) => handleSort(category.id, brand.id, ...params)}/>
                </Panel>
              )
            })
          }
        })
      }
    </Accordion>
  )
};

export default CategoryAccordion

// <CategorySortable key={`item-${index}`} index={index} value={value}/>


// WEBPACK FOOTER //
// ./src/components/admin/products/common/category-accordion.jsx